import $ from 'jquery';
window.jQuery = $;

import 'slick-carousel';

import Carousel from './components/carousel';
import Parallax from './components/parallax';
import Navigation from './components/navigation'; 
import InView from './components/inviewport';
import Type from './components/type';

jQuery(document).ready(() => {
   Navigation();
   Parallax();
   InView();
   Type();
   Carousel();
});


$(window).scroll(function () {
   InView();
});

